const $ = jQuery;

$(function () {
  // all lines
  const lines = $('.line');

  // create lines
  function createLine(lineId, div1Id, div2Id) {
    const div1 = $('#' + div1Id);
    const div2 = $('#' + div2Id);

    if (!div1.length || !div2.length) {
      return;
    }

    const x1 = div1.offset().left + div1.width() / 2;
    const y1 = div1.offset().top + div1.height() / 2;

    const x2 = div2.offset().left + div2.width() / 2;
    const y2 = div2.offset().top + div2.height() / 2;

    $('#' + lineId)
      .attr('x1', x1)
      .attr('y1', y1)
      .attr('x2', x2)
      .attr('y2', y2);
  }

  // create all lines
  function createLines() {
    if ($(window).width() > 1024) {
      lines.each(function () {
        const lineId = $(this).attr('id');
        const div1Id = $(this).data('start');
        const div2Id = $(this).data('finish');

        createLine(lineId, div1Id, div2Id);
      });
    }
  }
  createLines();

  // reposition lines on resize
  const resizeDelay = 0;
  let resizeId;

  $(window).resize(function () {
    clearTimeout(resizeId);
    if (resizeDelay !== 0) {
      resizeId = setTimeout(createLines, resizeDelay);
    } else {
      createLines();
    }
  });
});
